export const formatDate = (startDate, endDate) => {
    if (!startDate || !endDate) return "N/A"; // Handle undefined dates
    const start = new Date(startDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    const end = new Date(endDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    return start === end ? start : `${start} - ${end}`;
};
